import React from 'react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { StartingDataTable } from '../../components/StartingDataTable';
import { CautionNote } from '../../components/page/CautionNote';
import { TechAssistCallout } from '../../components/page/TechAssistCallout';
import { RelatedLinks } from '../../components/page/RelatedLinks';
import { startingDataNote } from '../../data/startingData';
export function StartingDataPage() {
  usePageMeta({
    title: 'Starting Data: Speeds, Feeds & DOC | Robertson Precision',
    description: 'Published Shear Geometry starting guidance for 6061-T6 aluminum, oxygen-free copper and titanium: speed (SFM), DOC per side and feed (IPR) with source conditions.',
    canonical: canonicalFor('/technical-resources/starting-data/')
  });
  return <>
      <PageHeader eyebrow="Technical Resources" title="Starting Data" lead="The published starting guidance for each material in one place. Speed is in surface feet per minute (SFM), depth of cut is per side in inches, and feed is in inches per revolution (IPR)." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Technical Resources',
      href: '/technical-resources/'
    }, {
      label: 'Starting Data'
    }]} data-id="element-853" data-mp="3h11uf9h74bfy" />

      <ContentSection id="data" data-id="element-854" data-mp="3jsx1oo32yhg2">
        <StartingDataTable linkMaterials data-id="element-855" data-mp="3ju868q4cnt88" />
        <div className="mt-8" data-id="element-856" data-mp="3etu6dvcwjpla">
          <CautionNote data-id="element-857" data-mp="3eulr2b4yo2ws">
            <p data-id="element-858" data-mp="3evdm9kunbymj">{startingDataNote}</p>
            <p data-id="element-859" data-mp="3st28aw0g9bt6">
              The workholding chart on Workholding &amp; Safety is a separate
              published reference with some different values — don’t combine
              the two tables.
            </p>
          </CautionNote>
        </div>
      </ContentSection>

      <ContentSection id="help" tone="warm" data-id="element-860" data-mp="140zp9z0ne05t">
        <TechAssistCallout location="starting-data" data-id="element-861" data-mp="1407ugqevk6gl" />
      </ContentSection>

      <RelatedLinks links={[{
      label: 'Workholding & Safety',
      href: '/technical-resources/safety/',
      description: 'Setup checks and the workholding chart.'
    }, {
      label: 'Aluminum',
      href: '/applications/aluminum/',
      description: '6061-T6 roughing and chip control.'
    }, {
      label: 'Copper & Soft Alloys',
      href: '/applications/copper-soft-alloys/',
      description: 'Peck cycle and oxygen-free copper.'
    }, {
      label: 'Titanium',
      href: '/applications/titanium/',
      description: 'DR80 starting range.'
    }]} data-id="element-862" data-mp="qvc6cfq9fgl" />
    </>;
}